// The target calculation year is not editable on every record the Program section can edit, so
// the editor and the card that now hosts it have to agree on one predicate. The card needs it to
// explain a disabled pencil; the editor needs it to refuse a save.
import type { BenefitDetailDto } from "./benefit-types"

/** A grantless unified draft with no certification, payment or eligibility history. */
export function isUnifiedTargetYearDraft(benefit: BenefitDetailDto): boolean {
  return benefit.benefitApplicationType === 100 && benefit.benefitGrants.length === 0 &&
    benefit.certificationDate == null && benefit.amountPaid === 0 && benefit.amountEligible === 0 && benefit.amountUnused === 0
}

/** Legacy Draft/Pending are 0/255; V2 editable intake states retain the compatibility 255 byte.
 * Completed (10) is deliberately excluded even when the older edit permission allows other fields. */
export function isEditableIntakeState(benefit: BenefitDetailDto): boolean {
  return benefit.proofingStatus === 0 || benefit.proofingStatus === 255
}

/** Why the target calculation year cannot be changed on this record, or null when it can. */
export function targetYearRecordReason(benefit: BenefitDetailDto): string | null {
  if (!isUnifiedTargetYearDraft(benefit)) {
    return "The target calculation year can only be changed on a draft with no grants, certification or payments. Completed, historical and financial records keep the year they were calculated with."
  }
  if (!isEditableIntakeState(benefit)) {
    return "The target calculation year can only be changed while the application is still in an editable intake state."
  }
  return null
}

/** Server status vocabulary for a published program year. */
export function targetYearStatusLabel(status: string): string {
  switch (status) {
    case "available": return "available"
    case "notEffective": return "not yet effective"
    case "configurationPending": return "configuration pending"
    case "unpublished": return "not published"
    default: return status
  }
}
